<template>
  <div style="height: 100%">
    <!--      头部      -->
    <bread></bread>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px" @change="search"> </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="订单编号/会员名/账号" @keyup.enter.native="search" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="search()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <download-excel v-if="orderListData.length > 0" :data="orderListData" :fields="json_fields" worksheet="My Worksheet" :header="title" :name="`${title}.xls`" class="excel">
                  <el-button type="warning" size="small" class="el-icon-download">导出当前页数据</el-button>
                </download-excel>
              </el-form-item>
              <el-form-item>
                <download-excel v-if="OrderTotal" :fields="json_fields" :fetch="fetchData" worksheet="My Worksheet" :header="title" :name="`${title}_All.xls`" class="excel">
                  <el-button type="danger" size="small" class="el-icon-download">导出{{ OrderTotal }}条数据</el-button>
                </download-excel>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-table :data="orderListData" height="calc(100% - 80px)" stripe style="width: 100%">
          <el-table-column prop="orderNum" label="订单编号" width="300px"> </el-table-column>
          <el-table-column prop="agent.name" label="所属代理商" align="center"> </el-table-column>
          <el-table-column prop="user.userName" label="会员名" align="center"> </el-table-column>
          <el-table-column prop="user.phone" label="会员账号" align="center"> </el-table-column>
          <el-table-column prop="paySuccessTime" label="支付时间" width="200px" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.paySuccessTime | timefilters }}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="upgradeType" label="升级类型" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.upgradeType == 0">后台升级</p>
              <p v-if="scope.row.upgradeType == 1">自己升级</p>
              <p v-if="scope.row.upgradeType == 2">开通赠送</p>
            </template>
          </el-table-column> -->
          <el-table-column prop="money" label="金额（元）" align="center"> </el-table-column>
          <el-table-column label="开通时长" align="center">
            <template #default="scope">
              <p v-if="scope.row.payType == 1">{{ scope.row.payLength + "月" }}</p>
              <p v-if="scope.row.payType == 2">{{ scope.row.payLength + "季" }}</p>
              <p v-if="scope.row.payType == 3">{{ scope.row.payLength + "年" }}</p>
              <p v-if="scope.row.payType == 4">{{ scope.row.payLength + "天" }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="payWay" label="支付方式" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.payWay == 0">余额</p>
              <p v-if="scope.row.payWay == 1">微信支付</p>
              <p v-if="scope.row.payWay == 2">支付宝</p>
              <p v-if="scope.row.payWay == 3">银行卡</p>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="开通类型" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.payType == 1">月付</p>
              <p v-if="scope.row.payType == 2">季付</p>
              <p v-if="scope.row.payType == 3">年付</p>
              <p v-if="scope.row.payType == 4">天付</p>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex" :total="OrderTotal" layout="total, prev, pager, next, jumper"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { WeChatPay } from "../../../components/HospitalDomain/WeChatPay";
import { RenewalUpgrade } from "../../../components/HospitalDomain/RenewalUpgrade";
export default {
  name: "VipOrder",
  data() {
    var renewalUpgrade = new RenewalUpgrade(this.TokenClient, this.Services.Authorization);
    var wechat = new WeChatPay(this.TokenClient, this.Services.Authorization);
    return {
      RenewalDomain: renewalUpgrade,
      WechatPayDomain: wechat,
      orderListData: [],
      Keyword: "",
      OrderTotal: 0,
      PageIndex: 1,
      PageSize: 15,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchForm: {
        statrTime: "",
        endTime: "",
        keyWord: "",
        datepicker: "",
        upgradeType: "-1",
      },
      title: "会员自主升级记录",
      json_fields: {
        订单编号: {
          filed: "orderNum",
          callback: (val) => {
            return val.orderNum;
          },
        },
        所属代理商: {
          filed: "agent",
          callback: (val) => {
            return val.agent.name;
          },
        },
        会员名: {
          filed: "user",
          callback: (val) => {
            return val.user.userName;
          },
        },
        会员账号: {
          filed: "user",
          callback: (val) => {
            return val.user.phone;
          },
        },
        支付时间: {
          filed: "paySuccessTime",
          callback: (val) => {
            var val = val.paySuccessTime;
            return this.$fliters.timefilters(val);
          },
        },
        金额: "money",
        开通时长: "payLength",
        开通时长类型: {
          filed: "payType",
          callback: (val) => {
            var val = val.payType;
            var str = "";
            switch (val) {
              case 1:
                str = "月";
                break;
              case 2:
                str = "季";
                break;
              case 3:
                str = "年";
                break;
              case 4:
                str = "天";
                break;
            }
            return str;
          },
        },
        支付方式: {
          filed: "payWay",
          callback: (val) => {
            var val = val.payWay;
            var str = "";
            switch (val) {
              case 1:
                str = "微信";
                break;
              case 2:
                str = "支付宝";
                break;
              case 0:
                str = "余额";
                break;
              case 3:
                str = "银行卡";
                break;
            }
            return str;
          },
        },
        开通类型: {
          filed: "payType",
          callback: (val) => {
            var val = val.payType;
            var str = "";
            switch (val) {
              case 1:
                str = "月付";
                break;
              case 2:
                str = "季付";
                break;
              case 3:
                str = "年付";
                break;
              case 4:
                str = "天付";
                break;
            }
            return str;
          },
        },
      },
    };
  },
  mounted() {
    this.orderList();
  },
  methods: {
    ChangePage(pageIndex) {
      this.PageIndex = pageIndex;
      this.orderList();
    },
    search() {
      this.PageIndex = 1;
      this.orderList();
    },
    async fetchData() {
      var _this = this;
      return await _this.getAllData();
    },
    getAllData() {
      var _this = this;
      return new Promise((resolve, reject) => {
        var item = _this.searchForm;
        if (_this.searchForm.datepicker) {
          item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
          item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
        } else {
          item.startTime = "";
          item.endTime = "";
        }
        _this.WechatPayDomain.GetOrgUserVersionOrderRecords(
          _this.searchForm.keyWord,
          item.startTime,
          item.endTime,
          1,
          1,
          _this.OrderTotal,
          function (data) {
            resolve(data.data.results);
          },
          function (err) {
            resolve("");
            console.log(err);
          }
        );
      });
    },
    orderList() {
      var _this = this;
      var item = _this.searchForm;
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
      _this.WechatPayDomain.GetOrgUserVersionOrderRecords(
        _this.searchForm.keyWord,
        item.startTime,
        item.endTime,
        1,
        _this.PageIndex,
        _this.PageSize,
        function (data) {
          _this.orderListData = data.data.results;
          _this.OrderTotal = data.data.dataTotal;
          _this.PageIndex = data.data.pageIndex;
          _this.PageSize = data.data.pageSize;
        },
        function (err) {
          _this.orderListData = [];
        }
      );
    },
  },
};
</script>

